import classNames from "classnames";
import { type FC, type ReactNode } from "react";

import styles from "./Subtitle.module.scss";

interface SubtitleProps {
  children: ReactNode;
  className?: string;
  testId?: string;
}

export const Subtitle: FC<SubtitleProps> = ({ children, className, testId }) => {
  return (
    <h2 data-test-id={testId} className={classNames(styles.subtitle, className)}>
      {children}
    </h2>
  );
};
